import Icon from '../Icon';
import type { IconNode, LucideProps } from '../types';

const iconNode: IconNode = [
  ['path', { d: 'm14.305 19.53.923-.382', key: '3m78fa' }],
  ['path', { d: 'm15.228 16.852-.923-.383', key: 'npixar' }],
  ['path', { d: 'm16.852 15.228-.383-.923', key: '5xggr7' }],
  ['path', { d: 'm16.852 20.772-.383.924', key: 'dpfhf9' }],
  ['path', { d: 'm19.148 15.228.383-.923', key: '1reyyz' }],
  ['path', { d: 'm19.53 21.696-.382-.924', key: '1goivc' }],
  ['path', { d: 'M2 21a8 8 0 0 1 10.434-7.62', key: '1yezr2' }],
  ['path', { d: 'm20.772 16.852.924-.383', key: 'htqkph' }],
  ['path', { d: 'm20.772 19.148.924.383', key: '9w9pjp' }],
  ['circle', { cx: '10', cy: '8', r: '5', key: 'o932ke' }],
  ['circle', { cx: '18', cy: '18', r: '3', key: '1xkwt0' }],
];

/**
 * @component @name UserRoundCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQuMzA1IDE5LjUzLjkyMy0uMzgyIiAvPgogIDxwYXRoIGQ9Im0xNS4yMjggMTYuODUyLS45MjMtLjM4MyIgLz4KICA8cGF0aCBkPSJtMTYuODUyIDE1LjIyOC0uMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAyMC43NzItLjM4My45MjQiIC8+CiAgPHBhdGggZD0ibTE5LjE0OCAxNS4yMjguMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE5LjUzIDIxLjY5Ni0uMzgyLS45MjQiIC8+CiAgPHBhdGggZD0iTTIgMjFhOCA4IDAgMCAxIDEwLjQzNC03LjYyIiAvPgogIDxwYXRoIGQ9Im0yMC43NzIgMTYuODUyLjkyNC0uMzgzIiAvPgogIDxwYXRoIGQ9Im0yMC43NzIgMTkuMTQ4LjkyNC4zODMiIC8+CiAgPGNpcmNsZSBjeD0iMTAiIGN5PSI4IiByPSI1IiAvPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iMTgiIHI9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/user-round-cog
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UserRoundCog = (props: LucideProps) => (
  <Icon {...props} iconNode={iconNode} name="user-round-cog" />
);

export default UserRoundCog;
